/**
 * Sandbox garage catalog — terrain + playable ship options.
 * Card copy/images are temporary placeholders for later polish.
 */

export type TerrainId = 'horizon' | 'mers';
export type ShipId = 'xwing' | 'arrowhead' | 'f22';

export interface CatalogCard {
  id: string;
  name: string;
  description: string;
  tags: string[];
  coverUrl: string;
}

export interface TerrainOption extends CatalogCard {
  id: TerrainId;
}

export interface ShipOption extends CatalogCard {
  id: ShipId;
}

export const TERRAIN_OPTIONS: readonly TerrainOption[] = [
  {
    id: 'horizon',
    name: 'Horizon',
    description:
      'Infinite dual-grid corridor through the void. The default digital runway — clean lines, dark sky, endless depth.',
    tags: ['Default', 'Grid', 'Void'],
    coverUrl: '/terrains/horizon.jpg',
  },
  {
    id: 'mers',
    name: 'Mers',
    description:
      'Dusty red lowlands under a thin blue sky. Rough dunes replace the floor grid; fly low over a Mars-like plain.',
    tags: ['Mars', 'Dunes', 'Sky'],
    coverUrl: '/terrains/mers.jpg',
  },
] as const;

export const SHIP_OPTIONS: readonly ShipOption[] = [
  {
    id: 'xwing',
    name: 'X-Wing',
    description:
      'Brick-built white fighter with red wing markings. Balanced hitbox, classic LEGO silhouette — the home fleet standard.',
    tags: ['Fighter', 'Brick', 'Default'],
    coverUrl: '/ships/xwing.jpg',
  },
  {
    id: 'arrowhead',
    name: 'Arrowhead',
    description:
      'Grey/black twin-EDF interceptor. Sharp delta planform and industrial jets — same hull as the sandbox foe craft.',
    tags: ['Interceptor', 'Delta', 'Heavy'],
    coverUrl: '/ships/arrowhead.jpg',
  },
  {
    id: 'f22',
    name: 'F-22 Raptor',
    description:
      'Dev-only brick stealth air-superiority fighter. Diamond wing, canted tails, dual 2D nozzles — grey airframe with afterburner glow.',
    tags: ['Dev', 'Stealth', 'Fighter'],
    coverUrl: '',
  },
] as const;

export const DEFAULT_TERRAIN: TerrainId = 'horizon';
export const DEFAULT_SHIP: ShipId = 'xwing';

export function terrainLabel(id: TerrainId): string {
  return TERRAIN_OPTIONS.find((t) => t.id === id)?.name ?? id;
}

export function shipLabel(id: ShipId): string {
  return SHIP_OPTIONS.find((s) => s.id === id)?.name ?? id;
}
